import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function Alert({
  variant = 'default',
  title,
  children,
  className,
}: {
  variant?: 'default' | 'destructive' | 'warning' | 'success';
  title?: string;
  children?: ReactNode;
  className?: string;
}) {
  const styles = {
    default: 'border-border bg-muted/40 text-foreground',
    destructive: 'border-destructive/30 bg-destructive/10 text-destructive',
    warning: 'border-warning/30 bg-warning/10 text-warning',
    success: 'border-success/30 bg-success/10 text-success',
  }[variant];
  return (
    <div className={cn('rounded-md border px-3 py-2 text-sm', styles, className)} role="alert">
      {title && <p className="font-semibold">{title}</p>}
      {children}
    </div>
  );
}
